
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface TemplateTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  categoryOptions: string[];
}

export function TemplateTabs({
  activeTab,
  onTabChange,
  categoryOptions
}: TemplateTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="mb-6 overflow-visible">
      <TabsList className="mb-2 flex flex-wrap gap-1 overflow-visible">
        {categoryOptions.map((category) => (
          <TabsTrigger key={category} value={category} className="capitalize">
            {category}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
